import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "space-y-6"
};
const _hoisted_5 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_6 = {
  class: "col-span-2"
};
const _hoisted_7 = {
  key: 0,
  class: "relative group inline-block"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center gap-3"
};
const _hoisted_10 = {
  class: "flex items-center justify-between mb-4"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
  key: 0,
  class: "text-center py-8 text-slate-400 text-sm border border-dashed border-slate-200 rounded-lg"
};
const _hoisted_13 = {
  key: 1,
  class: "space-y-3"
};
const _hoisted_14 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_15 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_18 = ["onUpdate:modelValue", "disabled"];
const _hoisted_19 = ["onUpdate:modelValue", "disabled"];
const _hoisted_20 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  class: "relative"
};
const _hoisted_23 = ["src"];
import { ref, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { uploadFile } from '@/api/file';
import { compressImage } from '@/utils/imageCompress';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'BannerFormModal',
  props: {
    show: Boolean,
    isEdit: Boolean,
    bannerData: Object
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 表单数据
    const form = reactive({
      id: null,
      title: '',
      imageUrl: '',
      position: '',
      sort: 0,
      startTime: '',
      endTime: '',
      remark: '',
      platformConfigs: []
    });

    // 图片相关
    const imageInput = ref();
    const pendingImageFile = ref(null); // 待上传的本地文件
    const imagePreview = ref(''); // 本地预览URL
    const showImagePreview = ref(false); // 大图预览弹窗

    // 提交 loading
    const submitting = ref(false);

    // 位置选项
    const positionOptions = [{
      label: '首页',
      value: 'home'
    }, {
      label: '分类页',
      value: 'category'
    }];

    // 平台选项
    const platformOptions = [{
      label: '微信小程序',
      value: 1
    }, {
      label: '支付宝小程序',
      value: 2
    }, {
      label: '抖音小程序',
      value: 3
    }, {
      label: '快手小程序',
      value: 4
    }, {
      label: 'iOS',
      value: 5
    }, {
      label: 'Android',
      value: 6
    }, {
      label: 'H5',
      value: 7
    }];

    // 跳转类型选项
    const linkTypeOptions = [{
      label: '无跳转',
      value: 0
    }, {
      label: '应用内页面',
      value: 1
    }, {
      label: 'H5页面',
      value: 2
    }, {
      label: '资讯详情',
      value: 3
    }, {
      label: '产品详情',
      value: 4
    }, {
      label: '跳转其他小程序',
      value: 5
    }, {
      label: '跳转外部APP',
      value: 6
    }, {
      label: '平台特定功能',
      value: 7
    }];

    // 获取平台名称
    const getPlatformLabel = value => {
      return platformOptions.find(p => p.value === value)?.label || '';
    };

    // 监听显示/隐藏 初始化表单
    watch(() => props.show, val => {
      if (val) {
        if (props.isEdit && props.bannerData) {
          Object.assign(form, {
            id: props.bannerData.id,
            title: props.bannerData.title || '',
            imageUrl: props.bannerData.imageUrl || '',
            position: props.bannerData.position || '',
            sort: props.bannerData.sort || 0,
            startTime: props.bannerData.startTime || '',
            endTime: props.bannerData.endTime || '',
            remark: props.bannerData.remark || '',
            platformConfigs: (props.bannerData.platformConfigs || []).map(c => ({
              platform: c.platform,
              linkType: c.linkType || 0,
              linkValue: c.linkValue || '',
              extraParams: c.extraParams || ''
            }))
          });
          pendingImageFile.value = null;
          imagePreview.value = '';
        } else {
          resetForm();
        }
      }
    });
    const resetForm = () => {
      Object.assign(form, {
        id: null,
        title: '',
        imageUrl: '',
        position: '',
        sort: 0,
        startTime: '',
        endTime: '',
        remark: '',
        platformConfigs: []
      });
      pendingImageFile.value = null;
      imagePreview.value = '';
    };

    // 图片上传处理
    const triggerImageUpload = () => imageInput.value?.click();
    const handleImageChange = async event => {
      const file = event.target.files[0];
      if (!file) return;

      // 校验文件类型
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }

      // 校验文件大小（10MB）
      if (file.size > 10 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过10MB');
        return;
      }

      // 压缩后存到本地，仅预览不上传
      const compressed = await compressImage(file);
      pendingImageFile.value = compressed;
      imagePreview.value = URL.createObjectURL(compressed);
      // 清除已有的远程URL，表示需要重新上传
      form.imageUrl = '';
      event.target.value = '';
    };
    const removeImage = () => {
      form.imageUrl = '';
      pendingImageFile.value = null;
      imagePreview.value = '';
    };

    // 平台配置操作
    const addPlatformConfig = () => {
      form.platformConfigs.push({
        platform: null,
        linkType: 0,
        linkValue: '',
        extraParams: ''
      });
    };
    const removePlatformConfig = index => {
      form.platformConfigs.splice(index, 1);
    };

    // 获取已选中的平台列表（排除当前行）
    const getUsedPlatforms = currentIndex => {
      return form.platformConfigs.filter((_, i) => i !== currentIndex).map(c => c.platform).filter(p => p !== null);
    };

    // 关闭弹窗
    const handleClose = () => {
      emit('update:show', false);
    };

    // 提交
    const handleSubmit = async () => {
      // 校验必填项
      if (!form.imageUrl && !pendingImageFile.value) {
        return ElMessage.warning('请上传Banner图片');
      }
      if (!form.position) {
        return ElMessage.warning('请选择展示位置');
      }
      if (form.platformConfigs.length === 0) {
        return ElMessage.warning('请至少添加一个平台配置');
      }
      for (let i = 0; i < form.platformConfigs.length; i++) {
        if (!form.platformConfigs[i].platform) {
          return ElMessage.warning(`请选择第${i + 1}个平台配置的平台类型`);
        }
      }
      submitting.value = true;
      try {
        // 如果有待上传的本地图片，先上传
        let imageUrl = form.imageUrl;
        if (pendingImageFile.value) {
          const result = await uploadFile(pendingImageFile.value, 'banner', 'public');
          imageUrl = result.url || result;
        }
        const data = {
          title: form.title,
          imageUrl,
          position: form.position,
          sort: form.sort,
          startTime: form.startTime || undefined,
          endTime: form.endTime || undefined,
          remark: form.remark || undefined,
          platformConfigs: form.platformConfigs.map(c => ({
            platform: c.platform,
            linkType: c.linkType,
            linkValue: c.linkValue || undefined,
            extraParams: c.extraParams || undefined
          }))
        };
        if (props.isEdit) {
          data.id = form.id;
        }
        emit('confirm', data);
      } catch (error) {
        ElMessage.error('图片上传失败');
      } finally {
        submitting.value = false;
      }
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "4xl",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.isEdit ? '编辑Banner' : '新增Banner'), 1), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-4"
          }, "基本信息", -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "Banner标题", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.title = $event),
            type: "text",
            placeholder: "请输入Banner标题",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.title]])]), _createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 展示位置 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.position,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.position = $event),
            placeholder: "请选择展示位置",
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(positionOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序值", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.sort = $event),
            type: "number",
            min: "0",
            placeholder: "值越小越靠前",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.sort, void 0, {
            number: true
          }]])]), _cache[16] || (_cache[16] = _createElementVNode("div", null, null, -1)), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "生效开始时间", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.startTime = $event),
            type: "datetime-local",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.startTime]])]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "生效结束时间", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.endTime = $event),
            type: "datetime-local",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.endTime]])]), _createElementVNode("div", _hoisted_6, [_cache[15] || (_cache[15] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.remark = $event),
            rows: "2",
            placeholder: "请输入备注信息",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.remark]])])])]), _createElementVNode("div", null, [_cache[22] || (_cache[22] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-4"
          }, [_createTextVNode(" Banner图片 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), form.imageUrl || imagePreview.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
            src: form.imageUrl || imagePreview.value,
            alt: "Banner预览",
            class: "h-36 rounded-lg border border-slate-200 object-cover"
          }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = $event => showImagePreview.value = true),
            class: "flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40 cursor-pointer",
            title: "查看大图"
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
          })], -1)]))]), _createElementVNode("button", {
            onClick: triggerImageUpload,
            class: "flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40 cursor-pointer",
            title: "更换图片"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)]))]), _createElementVNode("button", {
            onClick: removeImage,
            class: "flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-red-500/80 cursor-pointer",
            title: "删除图片"
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))])])])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: triggerImageUpload,
            class: "w-full h-36 border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center hover:border-primary-400 hover:bg-primary-50/30 transition-colors cursor-pointer"
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-8 h-8 text-slate-400 mb-2",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1), _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "点击选择Banner图片", -1), _createElementVNode("span", {
            class: "text-xs text-slate-400 mt-1"
          }, "建议尺寸 750x340，支持JPG/PNG，不超过10MB", -1)]))])), _createElementVNode("input", {
            ref_key: "imageInput",
            ref: imageInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleImageChange
          }, null, 544)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_cache[24] || (_cache[24] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, [_createTextVNode(" 平台跳转配置 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("button", {
            onClick: addPlatformConfig,
            disabled: form.platformConfigs.length >= 7,
            class: "inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 添加平台 ", -1)]))], 8, _hoisted_11)]), form.platformConfigs.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 暂无平台配置，请点击上方按钮添加 ")) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.platformConfigs, (config, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "bg-slate-50 rounded-lg p-4 border border-slate-200"
            }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, [_createTextVNode(" 平台配置 #" + _toDisplayString(index + 1) + " ", 1), config.platform ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(" - " + _toDisplayString(getPlatformLabel(config.platform)), 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("button", {
              onClick: $event => removePlatformConfig(index),
              class: "p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors cursor-pointer"
            }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("label", {
              class: "block text-xs font-medium text-slate-600 mb-1"
            }, [_createTextVNode(" 平台类型 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _createVNode(_component_el_select, {
              modelValue: config.platform,
              "onUpdate:modelValue": $event => config.platform = $event,
              placeholder: "请选择平台",
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(platformOptions, opt => {
                return _createVNode(_component_el_option, {
                  key: opt.value,
                  label: opt.label,
                  value: opt.value,
                  disabled: getUsedPlatforms(index).includes(opt.value)
                }, null, 8, ["label", "value", "disabled"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("label", {
              class: "block text-xs font-medium text-slate-600 mb-1"
            }, "跳转类型", -1)), _createVNode(_component_el_select, {
              modelValue: config.linkType,
              "onUpdate:modelValue": $event => config.linkType = $event,
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(linkTypeOptions, opt => {
                return _createVNode(_component_el_option, {
                  key: opt.value,
                  label: opt.label,
                  value: opt.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
              class: "block text-xs font-medium text-slate-600 mb-1"
            }, "跳转目标值", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => config.linkValue = $event,
              type: "text",
              placeholder: "页面路径/URL/目标ID",
              disabled: config.linkType === 0,
              class: "form-input w-full disabled:cursor-not-allowed"
            }, null, 8, _hoisted_18), [[_vModelText, config.linkValue]])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
              class: "block text-xs font-medium text-slate-600 mb-1"
            }, "扩展参数", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => config.extraParams = $event,
              type: "text",
              placeholder: "JSON格式，如{\"appId\":\"wx123\"}",
              disabled: config.linkType === 0,
              class: "form-input w-full disabled:cursor-not-allowed"
            }, null, 8, _hoisted_19), [[_vModelText, config.extraParams]])])])]);
          }), 128))]))])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("button", {
            onClick: handleClose,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value,
            class: "btn-primary"
          }, _toDisplayString(submitting.value ? '提交中...' : '确定'), 9, _hoisted_21)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showImagePreview.value,
          size: "none",
          "panel-class": "max-w-[90vw]",
          "z-index": 60,
          onClose: _cache[8] || (_cache[8] = $event => showImagePreview.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
            src: form.imageUrl || imagePreview.value,
            alt: "Banner大图",
            class: "max-w-full max-h-[85vh] rounded-lg object-contain"
          }, null, 8, _hoisted_23), _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = $event => showImagePreview.value = false),
            class: "absolute -top-3 -right-3 flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-lg text-slate-500 hover:text-slate-700 transition-colors cursor-pointer"
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};